<template>
  <OutlinedCard
    v-if="canViewUserCognito"
    :title="$t('modules.users.update.sectionCognito.title')"
    class="mb-6"
    :switchLabel="$t('modules.users.update.sectionCognito.fields.enabledDisabled')"
    :switchValue="isCognitoUser"
    @switchChange="isCognitoUserChange"
    switcher 
    >
    <v-container>
      <v-row no-gutters>
        <v-col sm="4" class="d-flex align-start pb-0 pt-4">
            <span class="caption text-uppercase">{{ $t('modules.users.update.sectionCognito.fields.name') }}</span>
        </v-col>
        <v-col sm="4" class="align-start pt-4 pb-3">
            <h2 class="body-2"> {{ calculatedInfo.name }} </h2>
        </v-col>
      </v-row>
      <v-row no no-gutters>
        <v-col sm="4" class="d-flex align-start pb-0 pt-4">
          <span class="caption text-uppercase">{{ $t('modules.users.update.sectionCognito.fields.familyName' ) }}</span>
        </v-col>
        <v-col sm="4" class="align-start pt-4 pb-3">
          <h2 class="body-2"> {{ calculatedInfo.familyName }} </h2>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col sm="4" class="d-flex align-start pb-0 pt-4">
          <span class="caption text-uppercase"> {{ $t('modules.users.update.sectionCognito.fields.identification') }}</span>
        </v-col>
        <v-col sm="4" class="align-start pt-4 pb-3">
          <h2 class="body-2"> {{ calculatedInfo.identification }} </h2>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col sm="4" class="d-flex align-start pb-0 pt-4">
          <span class="caption text-uppercase"> {{ $t('modules.users.update.sectionCognito.fields.email') }} </span>
        </v-col>
        <v-col sm="4" class="align-start pt-4 pb-3">
          <h2 class="body-2"> {{ calculatedInfo.email }} </h2>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col sm="4" class="d-flex align-start pb-0 pt-4">
          <span class="caption text-uppercase"> {{ $t('modules.users.update.sectionCognito.fields.gender') }} </span>
        </v-col>
        <v-col sm="4" class="align-start pt-4 pb-3">
          <h2 class="body-2"> {{ calculatedInfo.gender }} </h2>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col sm="4" class="d-flex align-start pb-0 pt-4">
          <span class="caption text-uppercase"> {{ $t('modules.users.update.sectionCognito.fields.address') }} </span>
        </v-col>
        <v-col sm="4" class="align-start pt-4 pb-3">
          <h2 class="body-2"> {{ calculatedInfo.address }} </h2>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col sm="4" class="d-flex align-start pb-0 pt-4">
          <span class="caption text-uppercase"> {{ $t('modules.users.update.sectionCognito.fields.userLastModifiedDate') }} </span>
        </v-col>
        <v-col sm="4" class="align-start pt-4 pb-3">
          <h2 class="body-2"> {{ calculatedInfo.userLastModifiedDate }} </h2>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col sm="4" class="d-flex align-start pb-0 pt-4">
          <span class="caption text-uppercase"> {{ $t('modules.users.update.sectionCognito.fields.phoneNumber') }} </span>
        </v-col>
        <v-col sm="4" class="align-start pt-4 pb-3">
          <h2 class="body-2"> {{ calculatedInfo.phoneNumber }} </h2>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col sm="4" class="d-flex align-start pb-0 pt-4">
          <span class="caption text-uppercase"> {{ $t('modules.users.update.sectionCognito.fields.status') }} </span>
        </v-col>
        <v-col sm="4" class="align-start pt-4 pb-3">
          <h2 class="body-2"> {{ calculatedInfo.status }} </h2>
        </v-col>
      </v-row>
    </v-container>
  </OutlinedCard>
</template>

<script>
import OutlinedCard from '@/components/OutlinedCard/OutlinedCard';

export default {
  name: 'UserCognitoInfo',
  components: {
    OutlinedCard
  },
  props: {
    canViewUserCognito: Boolean,
    isCognitoUser: Boolean,
    cognitoAttributes: Object,
    cognitoUserStateText: String
  },
  computed: {
    calculatedInfo() {
    return {
      userLastModifiedDate: this.cognitoAttributes ? this.formatDate(this.cognitoAttributes.updated_at) : '-',
      name: this.cognitoAttributes?.name || '-',
      familyName: this.cognitoAttributes?.family_name || '-',
      identification: this.cognitoAttributes?.['custom:identification'] || '-',
      phoneNumber: this.cognitoAttributes?.phone_number || '-',
      address: this.cognitoAttributes?.address || '-',
      gender: this.cognitoAttributes?.gender || '-',
      email: this.cognitoAttributes?.email || '-',
      status: this.cognitoUserStateText || '-',
    };
}
  },
  methods: {
    isCognitoUserChange() {
      this.$emit('isCognitoUserChange', !this.isCognitoUser)
    },
    formatDate(timestamp) {
        if (timestamp) {
          const date = new Date(timestamp * 1000);
          return date.toLocaleString();
        }
        return '-';
      }
  },
}
</script>